import React, {useEffect, useState} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {GET_HEXOMATIC_USER} from '../../../graphql/queries';
import {closeIcon} from '../../../images/svgIcons';
import PricingCard from '../pricing-card';
import CustomModal from '../../customModal/index';
import EnterpriseForm from '../../enterprise-form';
import Button from '../../button';
import {Modal} from '../../../components/modal';

import pricingIcon from '../../../images/pricing/pricing-hint.png';
import {checkedCircleIcon} from '../../../images/svgIcons/index';
import Square from '../../square';
import './styles.scss';
import {getUserToken} from '../../../helpers';
import {integrationsListPricingUi} from '../../../constants/pricingIntegrationIcons';
import ReactTooltip from 'react-tooltip';
import {navigate} from 'gatsby';

export {integrationsList} from '../../../constants/pricingIntegrationIcons';

export const gold = [
  {
    isBold: true,
    text: 'All the benefits of Silver, plus:',
  },
  {
    isChecked: true,
    text: (
      <>
        Automation credits <br /> (Monthly renewing quota)
      </>
    ),
  },
  {
    select: true,
    text: 'Simultaneous running workflows',
  },

  {
    isChecked: true,
    text: (
      <div>
        <span className="unlimited">Unlimited</span> Simultaneous running workflows
      </div>
    ),
  },
  {
    isChecked: true,
    text: 'API',
  },
];

export const silver = [
  {
    isBold: true,
    text: 'All the benefits of Bronze, plus:',
  },
  {
    number: 4500,
    text: (
      <>
        Automation credits <br /> (Monthly renewing quota)
      </>
    ),
  },
  {
    number: 10,
    text: 'Simultaneous running workflows',
  },
  {
    isChecked: true,
    text: 'Scheduling',
  },
  {isChecked: true, text: 'Datacentre IP rotation'},
];

const enterPrise = [
  {
    isBold: true,
    text: 'All the benefits of Gold, plus:',
  },

  {
    isChecked: true,
    text: 'Personalized onboarding',
  },
  {
    isChecked: true,
    text: 'Team training',
  },

  {
    isChecked: true,
    text: 'Campaign setup and management',
  },
  {
    isChecked: true,
    text: 'Dedicated strategy consultant',
  },
];

export const hexomaticPackages = (name: string, credits: number, count: number, details?: boolean, showGoldSpecial?: boolean, monthly?: boolean) => {
  const obj = {
    FREE: [
      {
        number: credits,
        text: (
          <>
            Automation credits <br /> (Monthly renewing quota)
          </>
        ),
      },
      {
        number: count,
        text: 'Simultaneous running workflows',
      },
      // {
      //   number: 1,
      //   text: 'Create your own automation recipe',
      // },
      {
        isChecked: true,
        text: 'Export to CSV and Google sheets',
      },
      {
        isChecked: true,
        text: 'Notifications to Telegram, Slack, email',
      },
      {
        isChecked: true,
        text: 'Get access to workflow templates',
      },
    ],
    BRONZE: [
      {
        number: 2000,
        text: (
          <>
            Automation credits <br /> (Monthly renewing quota)
          </>
        ),
      },
      {
        number: 3,
        text: 'Simultaneous running workflows',
      },
      {
        text: (
          <div>
            <span className="unlimited">Unlimited</span> Create your own scraping recipes
          </div>
        ),
        isChecked: true,
      },
      {
        isChecked: true,
        text: (
          <div className="d-flex flex-wrap">
            <ReactTooltip backgroundColor="#A801FF" />
            {integrationsListPricingUi.map(item => (
              <img
                key={item.name}
                src={item.src}
                className="m-1"
                alt={item.name}
                style={{width: '22px'}}
                data-tip={item.name}
              />
            ))}
          </div>
        ),
      },
      {
        isChecked: true,
        text: (
          <>
            Access premium automations <br />
            (requires premium credits)
          </>
        ),
      },
      {
        isChecked: true,
        text: (
          <>
            Access residential proxies <br />
            (requires premium credits)
          </>
        ),
      },
    ],
    SILVER: details || !showGoldSpecial || monthly
      ? [
          {
            isChecked: true,
            text: 'Scheduling',
          },
          {
            number: 4500,
            text: (
              <>
                Automation credits <br /> (Monthly renewing quota)
              </>
            ),
          },
          {
            number: count,
            text: 'Simultaneous running workflows',
          },
          {
            text: (
              <div>
                <span className="unlimited">Unlimited</span> Create your own scraping recipes
              </div>
            ),
            isChecked: true,
          },
          {
            isChecked: true,
            text: (
              <div className="d-flex flex-wrap">
                <ReactTooltip backgroundColor="#A801FF" />
                {integrationsListPricingUi.map(item => (
                  <img
                    key={item.name}
                    src={item.src}
                    className="m-1"
                    alt={item.name}
                    style={{width: '22px'}}
                    data-tip={item.name}
                  />
                ))}
              </div>
            ),
          },
          {isChecked: true, text: 'Datacentre IP rotation'},
          {
            isChecked: true,
            text: (
              <>
                Access premium automations <br />
                (requires premium credits)
              </>
            ),
          },
          {
            isChecked: true,
            text: (
              <>
                Access residential proxies <br />
                (requires premium credits)
              </>
            ),
          },
        ]
      : silver,

    GOLD: details
      ? [
          {
            isChecked: true,
            text: 'Scheduling',
          },
          {
            number: credits,
            text: (
              <>
                Automation credits <br /> (Monthly renewing quota)
              </>
            ),
          },
          {
            isChecked: true,
            text: (
              <div>
                <span className="unlimited">Unlimited</span> Simultaneous running workflows
              </div>
            ),
          },
          {
            text: (
              <div>
                <span className="unlimited">Unlimited</span> Create your own scraping recipes
              </div>
            ),
            isChecked: true,
          },
          {
            isChecked: true,
            text: (
              <div className="d-flex flex-wrap">
                <ReactTooltip backgroundColor="#A801FF" />
                {integrationsListPricingUi.map(item => (
                  <img
                    key={item.name}
                    src={item.src}
                    className="m-1"
                    alt={item.name}
                    style={{width: '22px'}}
                    data-tip={item.name}
                  />
                ))}
              </div>
            ),
          },
          {isChecked: true, text: 'Datacentre IP rotation'},
          {
            isChecked: true,
            text: (
              <>
                Access premium automations <br />
                (requires premium credits)
              </>
            ),
          },
          {
            isChecked: true,
            text: (
              <>
                Access residential proxies <br />
                (requires premium credits)
              </>
            ),
          },
          {
            isChecked: true,
            text: 'API',
          },
        ]
      : gold,
  };
  //@ts-ignore
  return obj[name];
};

const PricingPackeges = ({
  interval,
  products,
  promo,
  LTD,
  promoPage,
  goldSpecial,
  promoUser,
  setAnnual,
  specialLtd,
}: {
  products: any;
  interval: 'monthly' | 'ltd' | 'annual';
  promo?: boolean;
  LTD?: boolean;
  promoPage?: boolean;
  goldSpecial?: boolean;
  promoUser?: boolean;
  setAnnual?: any;
  specialLtd?: boolean;
}) => {
  //-----------------------State--------------------------
  const [user, setUser] = useState<any>(null);
  const [verified, setVerified] = useState(false);
  const [currentPackage, setCurrentPackage] = useState('');
  const [currentPackageInterval, setCurrentPackageInterval] = useState('');
  const [showUpgradeContact, setShowUpgradeContact] = useState(true);
  const [canUseTrial, setCanUseTrial] = useState(true);
  const [trialPlans, setTrialPlans] = useState<string[]>(['SILVER']);
  const [packeges, setPackeges] = useState<{
    annual: any[];
    monthly: any[];
    ltd: any[];
  }>({annual: [], monthly: [], ltd: []});
  const [updatedPackages, setUpdatedPackages] = useState<{
    annual: any[];
    monthly: any[];
    ltd: any[];
  }>({annual: [], monthly: [], ltd: []});

  const [showEnterpriseModal, setShowEnterpriseModal] = useState(false);
  const [showSentMsg, setShowSentMsg] = useState(false);

  const [showLtd, setShowLtd] = useState(false);
  const [showGoldSpecial, setShowGoldSpecial] = useState(false);
  const [pendingPayment, setPendingPayment] = useState(false);

  //---------------------Queries--------------------------
  const {data: hexomaticUser, loading, refetch} = useQuery(GET_HEXOMATIC_USER, {
    fetchPolicy: 'no-cache',
  });
  //---------------------useEffects------------------------
  useEffect(() => {
    if (getUserToken()) {
      refetch();
    }
  }, [getUserToken()]);

  useEffect(() => {
    if (
      hexomaticUser &&
      hexomaticUser.User &&
      hexomaticUser.User.get &&
      hexomaticUser.HexomaticUser &&
      hexomaticUser.HexomaticUser.getByLegacyId
    ) {
      setVerified(hexomaticUser.User.get.verified);
      setUser({
        email: hexomaticUser.User.get.email,
        ...hexomaticUser.HexomaticUser.getByLegacyId,
      });
      setCurrentPackage(hexomaticUser.HexomaticUser.getByLegacyId.pricing_package);
      setCurrentPackageInterval(hexomaticUser.HexomaticUser.getByLegacyId.pricing_package_interval);
      typeof hexomaticUser.HexomaticUser.getByLegacyId.pending_payment === 'boolean'
        ? setPendingPayment(hexomaticUser.HexomaticUser.getByLegacyId.pending_payment)
        : setPendingPayment(false);
      typeof hexomaticUser.HexomaticUser.getByLegacyId.can_use_trial === 'boolean' &&
        setCanUseTrial(hexomaticUser.HexomaticUser.getByLegacyId.can_use_trial);
      hexomaticUser.HexomaticUser.getByLegacyId.trial_packages &&
        setTrialPlans(hexomaticUser.HexomaticUser.getByLegacyId.trial_packages);
    }

    if (
      hexomaticUser &&
      hexomaticUser.User &&
      hexomaticUser.User.get &&
      hexomaticUser.HexomaticUser &&
      hexomaticUser.HexomaticUser.getByLegacyId &&
      !hexomaticUser.HexomaticUser.getByLegacyId.error_code &&
      // hexomaticUser?.User?.get?.promoData?.hexomatic_ltd &&
      (hexomaticUser.HexomaticUser.getByLegacyId.pricing_package === 'FREE' ||
        !hexomaticUser.HexomaticUser.getByLegacyId.pricing_package ||
        hexomaticUser.HexomaticUser.getByLegacyId.pricing_package_interval === 'LTD') &&
      promoPage
    ) {
      setShowLtd(true);
    } else if (hexomaticUser?.HexomaticUser?.getByLegacyId?.error_code === 'USER_NOT_FOUND' && promoPage) {
      setShowLtd(true);
    } else {
      setShowLtd(false);
    }
  }, [hexomaticUser, promoPage]);

  useEffect(() => {
    const goldAnnual = currentPackage === 'FREE';
    if (
      // user?.promoData?.hexomatic_ltd &&
      goldSpecial && goldAnnual
      // currentPackageInterval &&
      // currentPackageInterval !== 'LTD'
      // !goldAnnual
    ) {
      setShowGoldSpecial(true);
      setAnnual && setAnnual(true);
    } else if (hexomaticUser?.HexomaticUser?.getByLegacyId?.error_code === 'USER_NOT_FOUND' && goldSpecial) {
      setShowGoldSpecial(true);
      setAnnual && setAnnual(true);
    } else {
      setShowGoldSpecial(false);
      setAnnual && setAnnual(false);
    }
  }, [user, goldSpecial, currentPackageInterval, currentPackage]);

  useEffect(() => {
    if (products) {
      const packages_annual: any = {};
      const packages_ltd: any = {};
      const packages: any = {};
      const paypal_packages_annual: any = {};
      const paypal_packages_ltd: any = {};
      const paypal_packages: any = {};
      products.map((item: any) => {
        const getLtdPlans = (item.name === 'GOLD' || item.name === 'SILVER') && showLtd && item.interval === 'ANNUAL';
        const getAnnualDiscount = promo && item.interval === 'ANNUAL';
        const getGoldSpecialPlans = showGoldSpecial && item.interval === 'ANNUAL';
        const checkGold = item.name === 'GOLD' ? (specialLtd ? (item.name === 'GOLD' && currentPackage === 'GOLD' ? 99 : 198) : 399) : null;
        const checkSilver = item.name === 'SILVER' ? (specialLtd ? 99 : 199) : null;
        const el = {
          id: getLtdPlans
            ? products.find((subItem: any) => subItem.interval === 'LTD' && (subItem.amount === checkGold || subItem.amount === checkSilver) && subItem.name === item.name)?.id
            : getGoldSpecialPlans
            ? products.find((subItem: any) => subItem.interval === 'ANNUAL_DISCOUNT_50' && subItem.name === item.name && subItem.productType === item.productType)?.id
            : getAnnualDiscount
            ? products.find((subItem: any) => subItem.interval === 'ANNUAL_DISCOUNT' && subItem.name === item.name && subItem.productType === item.productType)?.id
            : item.id,
          interval: item.interval,
          name: item.name,
          price: getAnnualDiscount
            ? products.find((subItem: any) => subItem.interval === 'ANNUAL_DISCOUNT' && subItem.name === item.name && subItem.productType === item.productType)
                ?.amount
            : item.name === 'BRONZE' && getGoldSpecialPlans ? 250 : item.amount,
          discountAnnual:
            item.interval === 'ANNUAL'
              ? products.find((subItem: any) => subItem.interval === 'ANNUAL_DISCOUNT' && subItem.name === item.name)
                  ?.amount
              : null,
          goldSpecialPrice: getGoldSpecialPlans
            ? products.find((subItem: any) => subItem.interval === 'ANNUAL_DISCOUNT_50' && subItem.name === item.name && subItem.productType === item.productType)
                ?.amount
            : null,
          ltdPrice: getLtdPlans
            ? products.find((subItem: any) => subItem.interval === 'LTD' && (subItem.amount === checkGold || subItem.amount === checkSilver) && subItem.name === item.name)?.amount
            : null,
          lineThrough: item.interval === 'LTD',
          trigger: !!(item.interval === 'LTD' && item.amount),
          flag: item.name === 'GOLD',
          real_price:
            item.interval === 'ANNUAL'
              ? products.find((subItem: any) => subItem.interval === 'MONTHLY' && subItem.name === item.name && subItem.productType === item.productType)?.amount
              : null,
          disabled: true,
          pricingList: hexomaticPackages(
            item.name,
            item.limits.credits_count,
            item?.actions?.workflow?.simultaneous_running_workflow_count || 0,
            item.name === 'SILVER',
            showGoldSpecial,
            interval === 'monthly'
          ),
        };
        if (item.name === 'FREE') {
          el.disabled = user && user.id;
        } else if (item.name === 'BRONZE') {
          el.disabled =
            (interval !== 'ltd' && user && user.pricing_package_interval === 'LTD') ||
            !currentPackage ||
            (currentPackage &&
              (currentPackage === 'BRONZE' || currentPackage === 'SILVER' || currentPackage === 'GOLD'))
              ? user && user.id
                ? true
                : false
              : false;
        } else if (item.name === 'SILVER') {
          el.disabled =
            (interval !== 'ltd' && user && user.pricing_package_interval === 'LTD') ||
            !currentPackage ||
            (currentPackage && (currentPackage === 'SILVER' || currentPackage === 'GOLD'))
              ? user && user.id
                ? true
                : false
              : false;
        } else
          el.disabled =
            showLtd && item.interval === 'ANNUAL'
              ? false
              : !showGoldSpecial && user?.billing_info?.is_promo
              ? true
              : interval !== 'ltd' && user && user.pricing_package_interval === 'LTD';
        if (item.productType === 'PAYPAL') {
          //@ts-ignore
          if (item.interval === 'ANNUAL') paypal_packages_annual[item.name] = el;
          //@ts-ignore
          // else if (item.interval === 'ANNUAL_DISCOUNT_50' && goldSpecial) paypal_packages_annual[item.name] = el;
          //@ts-ignore
          else if (item.interval === 'LTD') paypal_packages_ltd[item.name] = el;
          //@ts-ignore
          else if (item.interval === 'MONTHLY') paypal_packages[item.name] = el;
        } else {
          //@ts-ignore
          if (item.interval === 'ANNUAL') packages_annual[item.name] = el;
           //@ts-ignore
          // else if (item.interval === 'ANNUAL_DISCOUNT_50' && goldSpecial) packages_annual[item.name] = el;
          //@ts-ignore
          else if (item.interval === 'LTD') packages_ltd[item.name] = el;
          //@ts-ignore
          else if (item.interval === 'MONTHLY') packages[item.name] = el;
        }
      });

      const plans = showGoldSpecial ? 
      {
        annual: [
          // packages.FREE,
          // {...packages_annual.BRONZE, paypal_id: paypal_packages_annual.BRONZE.id},
          {...packages_annual.SILVER, paypal_id: paypal_packages_annual.SILVER.id},
          {...packages_annual.GOLD, paypal_id: paypal_packages_annual.GOLD.id},
        ],
        ltd: [
          // packages.FREE,
          // {...packages_ltd.BRONZE, paypal_id: paypal_packages_ltd.BRONZE ? paypal_packages_ltd.BRONZE.id : null},
          {...packages_ltd.SILVER, paypal_id: paypal_packages_ltd.SILVER ? paypal_packages_ltd.SILVER.id : null},
          {...packages_ltd.GOLD, paypal_id: paypal_packages_ltd.GOLD ? paypal_packages_ltd.GOLD.id : null},
        ],
        monthly: [
          // packages.FREE,
          // {...packages.BRONZE, paypal_id: paypal_packages.BRONZE.id},
          {...packages.SILVER, paypal_id: paypal_packages.SILVER.id},
          {...packages.GOLD, paypal_id: paypal_packages.GOLD.id},
        ],
      } :
      {
        annual: [
          // packages.FREE,
          // {...packages_annual.BRONZE, paypal_id: paypal_packages_annual.BRONZE.id},
          {...packages_annual.SILVER, paypal_id: paypal_packages_annual.SILVER.id},
          {...packages_annual.GOLD, paypal_id: paypal_packages_annual.GOLD.id},
        ],
        ltd: [
          // packages.FREE,
          // {...packages_ltd.BRONZE, paypal_id: paypal_packages_ltd.BRONZE ? paypal_packages_ltd.BRONZE.id : null},
          {...packages_ltd.SILVER, paypal_id: paypal_packages_ltd.SILVER ? paypal_packages_ltd.SILVER.id : null},
          {...packages_ltd.GOLD, paypal_id: paypal_packages_ltd.GOLD ? paypal_packages_ltd.GOLD.id : null},
        ],
        monthly: [
          // packages.FREE,
          // {...packages.BRONZE, paypal_id: paypal_packages.BRONZE.id},
          {...packages.SILVER, paypal_id: paypal_packages.SILVER.id},
          {...packages.GOLD, paypal_id: paypal_packages.GOLD.id},
        ],
      };
      setPackeges(plans);
      let localPlans = {...plans};
      if (canUseTrial && trialPlans.includes('SILVER') && interval === 'monthly') {
        localPlans = {
          ...plans,
          monthly: [
            {...packages.SILVER, paypal_id: paypal_packages.SILVER.id, trial: true, name: 'Silver (7-day free trial)'},
            ...plans.monthly,
          ],
        };
      }
      setUpdatedPackages(localPlans);
    }
  }, [products, user, trialPlans, canUseTrial, showGoldSpecial]);

  const handleCloseModal = () => setShowUpgradeContact(false);

  return (
    <div className="pricing-packages-wrapper position-relative">
      {/* <Square size="small" className="small-element-position" /> */}
      {/* <Square size="medium" className="medium-element-position" />
      <Square size="large" className="large-element-position" /> */}
      {((interval !== 'ltd' && user?.pricing_package_interval === 'LTD' && !(showLtd && interval === 'annual')) ||
        (user?.paypal_subscription_id &&
          user?.pricing_package === 'GOLD' &&
          user?.pricing_package_interval === 'ANNUAL') ||
        (!showGoldSpecial && user?.billing_info?.is_promo)) &&
        showUpgradeContact && (
          <div className="text-center all-disabled">
            <span onClick={handleCloseModal}>{closeIcon}</span>
            <img src={pricingIcon} alt="icon" />
            <div>Need to upgrade your plan? </div>
            <div className="support">
              Please contact{' '}
              <a
                href="mailto:support@hexomatic.com"
                className="color-hexomatic"
                aria-label={'mail'}
                target="_blank"
                rel="noopener"
              >
                support@hexomatic.com
              </a>
              {'.'}
            </div>
          </div>
        )}
      <div className="pricing-cards-main-wrapper">
        {packeges[interval].map((item: any) => (
          <div
            className={`inner-wr ${item.name === 'FREE' && !showEnterpriseModal && !showSentMsg ? 'z_index_2' : ''}`}
          >
            <PricingCard
              trigger={interval === 'ltd' ? item.price : undefined}
              name={item.name[0] + item.name.slice(1).toLowerCase()}
              price={item.price}
              lineThrough={item.lineThrough}
              flag={item.flag}
              pricingList={item.pricingList}
              ltdPrice={item.ltdPrice}
              showLtd={showLtd}
              goldSpecialPrice={item.goldSpecialPrice}
              goldSpecial={goldSpecial}
              specialLtd={specialLtd}
              disabled={
                item.disabled ||
                loading ||
                !user ||
                (interval === 'annual'
                  ? user?.paypal_subscription_id &&
                    user?.pricing_package === 'GOLD' &&
                    user?.pricing_package_interval === 'ANNUAL'
                  : user?.paypal_subscription_id && user?.pricing_package === 'GOLD')
              }
              user={user}
              packeges={updatedPackages[interval]}
              interval={interval}
              verified={verified}
              id={item.id}
              refetch={refetch}
              promo={promo}
              discountAnnual={promo ? item.discountAnnual : null}
              real_price={item.real_price}
              paypal_id={item.paypal_id}
              currentPlan={currentPackage}
              currentPlanInterval={currentPackageInterval}
              pendingPayment={pendingPayment}
            />
          </div>
        ))}
        <div className={`inner-wr ${!showEnterpriseModal && !showSentMsg ? 'z_index_2' : ''}`}>
          <PricingCard
            trigger={0}
            name="Enterprise"
            price={0}
            lineThrough={false}
            flag={undefined}
            handleEnterpriseClick={() => navigate('/enterprise')}
            pricingList={enterPrise}
            disabled={false}
            user={user}
            isEnterprise
            packeges={updatedPackages[interval]}
            interval={interval}
            verified={verified}
            showLtd={showLtd}
            goldSpecial={goldSpecial}
            id={'Enterprise'}
            refetch={refetch}
            promo={promo && interval === 'annual'}
            discountAnnual={null}
          />
        </div>
      </div>

      {showEnterpriseModal && (
        <CustomModal setShowPopup={setShowEnterpriseModal} noNavigate className="enterprise-popup">
          <EnterpriseForm setShowEnterpriseModal={setShowEnterpriseModal} setShowSentMsg={setShowSentMsg} />
        </CustomModal>
      )}

      <Modal
        isOpen={showSentMsg}
        modalFooter={
          <Button primary onClick={() => setShowSentMsg(false)}>
            Close
          </Button>
        }
        modalToggle={() => {}}
        title=""
      >
        <div className="d-flex mt-3 flex-column align-items-center justify-content-center">
          <div className="check-icon">{checkedCircleIcon}</div>
          <div className="mt-3">
            <strong>The message has been successfully sent.</strong>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PricingPackeges;
